import OptionRows, {
  OptionRowsProps,
} from 'typescript/components/option_rows/option_rows';
import { HTMLAttributes, useEffect } from 'react';
import {
  CheckoutStepName,
  onCheckoutPageView,
  onCheckoutPageViewV2,
} from 'typescript/utilities/tracking';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';

interface OptionRowsWithLoggingProps
  extends HTMLAttributes<HTMLElement>,
    OptionRowsProps {
  componentName?: CheckoutStepName;
}

/**
 * Simple wrapper around the OptionRows component with standardized checkout logging.
 */
const OptionRowsWithLogging = ({
  className,
  dataTestId,
  disabled = false,
  header,
  options,
  onOptionSelect,
  componentName,
}: OptionRowsWithLoggingProps) => {
  const { trackingData } = useCheckoutFlow();

  useEffect(() => {
    if (componentName) {
      onCheckoutPageView({
        name: componentName,
        trackingData,
      });
      onCheckoutPageViewV2({
        componentName,
        additionalParameters: trackingData,
      });
    }
  }, []);

  return (
    <OptionRows
      dataTestId={dataTestId}
      disabled={disabled}
      header={header}
      className={className}
      options={options}
      onOptionSelect={onOptionSelect}
    />
  );
};

export default OptionRowsWithLogging;
